import { render, staticRenderFns } from "./wBelongsto.vue?vue&type=template&id=4a0d82f6&scoped=true&"
import script from "./wBelongsto.vue?vue&type=script&lang=js&"
export * from "./wBelongsto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0d82f6",
  null
  
)

export default component.exports